import React from 'react'
import { Helmet } from 'react-helmet';

// Page content
import {WeatherPanel} from "../../pagecontent/ts/weatherPanel";

export default function WeatherPanelPage() {
  return (
    <div>
        <Helmet>
            <title>氣象儀表板 | 專業氣象 Professional Meteorology</title>
        </Helmet>
        <div className='' id=''>
            <WeatherPanel />
        </div>
    </div>
  )
}